import React from 'react';

const Logo = () => {
  return (
    <div
      style={{
        width: 100,
        height: 39.3,
        backgroundImage: 'url(/images/logo-small.png)',
        backgroundSize: 'cover',
      }}
    />
  );
};

export default Logo;
